import * as React from 'react';
import { ApolloError } from 'apollo-client';
import { Query } from 'react-apollo';

import GET_STUDENT_DATA_QUERY from 'coaching/queries/GetProspectiveStudentOptions.gql';
import {
  GetProspectiveStudentOptions,
  GetProspectiveStudentOptions_coaching_studentFamilyMembers,
} from 'coaching/queries/__generated__/GetProspectiveStudentOptions';

export type Student = GetProspectiveStudentOptions_coaching_studentFamilyMembers;

export type Props = {
  children: (props: {
    students?: Student[];
    subjects?: string[];
    gradeLevels?: string[];
    loading: boolean;
    error?: ApolloError;
  }) => React.ReactNode;
};

export default function GetProspectiveStudentOptionsContainer(props: Props) {
  return (
    <Query<GetProspectiveStudentOptions> query={GET_STUDENT_DATA_QUERY}>
      {({ loading, error, data }) => {
        return props.children({
          students: data?.coaching?.studentFamilyMembers,
          subjects: data?.coaching?.getCoachableSubjects.subjects,
          gradeLevels: data?.coaching?.getGradeLevels.gradeLevels,
          loading,
          error,
        });
      }}
    </Query>
  );
}
